import { cleanHTML } from "../../utils/cleanHtml";
import { useLocation } from "react-router-dom";

export const TwoColsWithSS = ({ section }) => {
  const isVideo = /\.(mp4|webm|ogg)$/i.test(section.image_side);
  const mediaSrc = `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image_side}`;

  return (
    <section className="py-20 bg-white px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        {section.image_side ? (
          isVideo ? (
            <video
              src={mediaSrc}
              className="w-full rounded"
              autoPlay
              muted
              loop
              playsInline
            />
          ) : (
            <img
              src={mediaSrc}
              alt={section.title || "Image"}
              className="w-full rounded"
            />
          )
        ) : (
          <div className="min-h-[450px] w-full bg-orange-900 flex items-center justify-center text-orange-400 text-4xl">
            <i className="fas fa-image"></i>
          </div>
        )}

        {/* Titre principal + contenu + sous-sections */}
        <div className="mb-14">
          <h1 className="text-2xl md:text-4xl font-bold text-[#74BB43]">
            {section.title}
          </h1>
          {section.subtitle && (
            <p className="mt-3 text-gray-600 text-lg">{section.subtitle}</p>
          )}
          {section.content && (
            <div
              className="mt-6 text-gray-700 leading-relaxed text-justify"
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          )}
          {/* Sous-sections en cards */}
          <div className="flex flex-wrap justify-center gap-4">
            {section.subsections.map((item, index) => (
              <div
                key={index}
                className="w-[40%] lg:w-[31%] border border-gray-200 rounded-lg p-3 text-center hover:shadow-md transition-all duration-300"
              >
                {item.icon && (
                  <div className="text-[#74BB43] text-4xl mb-4">
                    <i className={item.icon}></i>
                  </div>
                )}
                <p className="font-semibold text-xs break-words text-gray-800">
                  {item.title}
                </p>
                {item.subtitle && (
                  <p className="mt-2 text-xs text-gray-600">{item.subtitle}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export const TwoColsWithoutSS = ({ section }) => {
  const location = useLocation();
  const loc = location.pathname === "/cda-motors";

  return (
    <div
      className={`py-[7rem] ${
        loc ? "bg-[#74BB432B]" : "bg-white"
      } px-6 md:px-12`}
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        {section.image_side ? (
          <img
            src={`${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image_side}`}
            alt={section.title || "Image"}
            className="w-full rounded"
          />
        ) : (
          <div className="min-h-[250px] max-h-[400px] w-full bg-orange-900 flex items-center justify-center text-orange-400 text-4xl">
            <i className="fas fa-image"></i>
          </div>
        )}
        {/* Titre principal */}
        <div className="mb-14">
          <h1 className="text-2xl md:text-4xl font-bold">{section.title}</h1>
          {section.subtitle && (
            <p className="mt-3 text-gray-600 text-lg">{section.subtitle}</p>
          )}
          {section.content && (
            <div
              className="mt-6 text-gray-700 leading-relaxed text-justify"
              dangerouslySetInnerHTML={{
                __html: section.content ? cleanHTML(section.content) : "",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export const TwoColsWithoutSSInverse = ({ section }) => {
  const location = useLocation();
  const loc = location.pathname === "/cda-motors";
  return (
    <section className="py-20 bg-white px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        {/* Titre principal */}
        <div className="mb-14">
          <h1
            className={`text-2xl md:text-4xl font-bold ${
              loc ? "text-orange-400" : ""
            }`}
          >
            {section.title}
          </h1>
          {section.subtitle && (
            <p className="mt-3 text-gray-600 text-lg">{section.subtitle}</p>
          )}
          {section.content && (
            <div
              className="mt-6 text-gray-700 leading-relaxed text-justify"
              dangerouslySetInnerHTML={{
                __html: section.content ? cleanHTML(section.content) : "",
              }}
            />
          )}
        </div>
        {section.image_side ? (
          <img
            src={`${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image_side}`}
            alt={section.title || "Image"}
            className="w-full rounded"
          />
        ) : (
          <div className="min-h-[450px] w-full bg-orange-900 flex items-center justify-center text-orange-400 text-4xl">
            <i className="fas fa-image"></i>
          </div>
        )}
      </div>
    </section>
  );
};

export const TwoColsWithInlineSS = ({ section }) => (
  <div className="py-[7rem] bg-white px-6 md:px-12">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
      {/* Image ou placeholder */}
      {section.image_side ? (
        <img
          src={`${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image_side}`}
          alt={section.title || "Image"}
          className="w-full rounded"
        />
      ) : (
        <div className="min-h-[450px] w-full bg-orange-900 flex items-center justify-center text-orange-400 text-4xl">
          <i className="fas fa-image"></i>
        </div>
      )}

      {/* Partie texte + sous-sections */}
      <div className="mb-14">
        {/* Titre principal */}
        <h1 className="text-2xl md:text-4xl font-bold">{section.title}</h1>

        {/* Sous-titre */}
        {section.subtitle && (
          <p className="mt-3 text-gray-600 text-lg">{section.subtitle}</p>
        )}

        {/* Contenu principal */}
        {section.content && (
          <div
            className="mt-6 text-gray-700 leading-relaxed text-justify"
            dangerouslySetInnerHTML={{ __html: section.content }}
          />
        )}

        {/* Sous-sections affichées inline */}
        {section.subsections?.length > 0 && (
          <div className="mt-8">
            {section.subsections.map((ss, index) => (
              <div
                key={index}
                className="py-4 flex justify-between items-center border-b border-gray-600"
              >
                <h4 className="font-semibold">{ss.title}</h4>
                <p className="mt-3 text-gray-600 text-lg">{ss.subtitle}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  </div>
);

export const TwoColsImageGrid = ({ section }) => {
  const images = section.subsections
    .filter((sub) => sub.image)
    .map((sub) => `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${sub.image}`);

  return (
    <section className="py-20 bg-white px-6 md:px-12">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-8 items-center">
        {/* Colonne gauche : texte */}
        <div className="mb-14">
          <h1 className="text-2xl md:text-4xl font-bold text-[#74BB43]">
            {section.title}
          </h1>
          {section.subtitle && (
            <p className="mt-3 text-gray-600 text-lg">{section.subtitle}</p>
          )}
          {section.content && (
            <div
              className="mt-6 text-gray-700 leading-relaxed text-justify"
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          )}
        </div>

        {/* Colonne droite : affichage d'images des sous-sections */}
        <div className="grid w-full h-full">
          {images.length === 1 && (
            <img
              src={images[0]}
              alt=""
              className="w-full object-cover rounded-lg"
            />
          )}

          {images.length === 2 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 h-full">
              {images.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt=""
                  className="w-full h-full object-cover rounded-lg"
                />
              ))}
            </div>
          )}

          {images.length === 3 && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:max-h-[400px]">
              {/* Partie gauche (image 1 sur 2 colonnes) */}
              <img
                src={images[0]}
                alt=""
                className="md:col-span-2 md:row-span-2 h-full w-full object-cover rounded-lg"
              />

              {/* Partie droite : images 2 et 3 empilées */}
              <div className="flex flex-col gap-4 md:h-full">
                <img
                  src={images[1]}
                  alt=""
                  className="w-full object-cover rounded-lg md:h-1/2"
                />
                <img
                  src={images[2]}
                  alt=""
                  className="w-full object-cover rounded-lg md:h-1/2"
                />
              </div>
            </div>
          )}

          {images.length >= 4 && (
            <div className="grid grid-cols-1 md:grid-cols-2 md:grid-rows-2 gap-4 h-auto md:h-[600px]">
              {images.slice(0, 4).map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt=""
                  className="w-full h-full object-cover rounded-lg"
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
